import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './P2pSellList.css';

// Mock data for P2P sell listings
const mockListings = [
  {
    id: 1,
    user: {
      name: 'Fast Trader',
      initial: 'F',
      verified: true,
      completionRate: '61.63%',
      orders: 106,
      avgTime: '15m'
    },
    price: '1430.00',
    currency: 'NGN',
    pair: 'NGN/USDT',
    limitMin: '1420.00',
    limitMax: '15730.00',
    available: '11',
    paymentMethods: ['MoniePoint', 'OPay', 'ZenithBank']
  },
  {
    id: 2,
    user: {
      name: 'Ubong Ben',
      initial: 'U',
      verified: true,
      completionRate: '75.00%',
      orders: 18,
      avgTime: '15m'
    },
    price: '1433.00',
    currency: 'NGN',
    pair: 'NGN/USDT',
    limitMin: '1433.00',
    limitMax: '14330.00',
    available: '10',
    paymentMethods: ['OPay', 'Palmpay']
  }
];

const P2pSellList: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'buy' | 'sell'>('sell');
  const [selectedCrypto, setSelectedCrypto] = useState('USDT');
  const [selectedCurrency, setSelectedCurrency] = useState('NGN');
  const [amount, setAmount] = useState('');

  const handleSellClick = () => {
    // Navigate to sell view when implemented
    console.log('Sell clicked');
  };

  return (
    <div className="p2p-container">
      {/* Header */}
      <header className="p2p-header">
        <button className="p2p-back-button" aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <h1 className="p2p-title">P2P Trading</h1>
        
        <div className="p2p-header-actions">
          <button className="p2p-store-button" aria-label="Store">
            <svg width="36" height="33" viewBox="0 0 36 33" fill="none">
              <path d="M2 8L18 2L34 8V22C34 23 33 24 32 24H4C3 24 2 23 2 22V8Z" stroke="currentColor" strokeWidth="2"/>
              <path d="M2 8L18 2L34 8" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
          
          <button className="p2p-my-ads-button">
            My Ads
          </button>
          
          <button className="p2p-my-trades-button">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M14 5.33333H10V1.33333H14V5.33333Z" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M6 5.33333H2V1.33333H6V5.33333Z" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M14 14.6667H10V10.6667H14V14.6667Z" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M6 14.6667H2V10.6667H6V14.6667Z" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
            <span>My Trades</span>
          </button>
        </div>
      </header>

      {/* Filters Section */}
      <div className="p2p-filters">
        <button className="p2p-crypto-selector">
          <div className="p2p-crypto-icon">₮</div>
          <span className="p2p-crypto-label">{selectedCrypto}</span>
        </button>
        
        <button className="p2p-payment-button">
          <span>Payment</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {/* Amount Input */}
      <div className="p2p-amount-section">
        <div className="p2p-amount-input">
          <input 
            type="text" 
            placeholder="Enter amount" 
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="p2p-input"
          />
          <span className="p2p-amount-label">Amount</span>
          <svg className="p2p-amount-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <button className="p2p-currency-selector">
          <span>{selectedCurrency}</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {/* Buy/Sell Tabs */}
      <div className="p2p-tabs">
        <button 
          className={`p2p-tab ${activeTab === 'buy' ? 'active' : ''}`}
          onClick={() => setActiveTab('buy')}
        >
          <div className="p2p-tab-icon">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 13V1M7 1L1 7M7 1L13 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <span>Buy</span>
        </button>
        
        <button 
          className={`p2p-tab ${activeTab === 'sell' ? 'active' : ''}`}
          onClick={() => setActiveTab('sell')}
        >
          <div className="p2p-tab-icon">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 1V13M7 13L13 7M7 13L1 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <span>Sell</span>
        </button>
      </div>

      {/* Listings */}
      <div className="p2p-listings">
        {mockListings.map((listing) => (
          <div key={listing.id} className="p2p-listing-card">
            {/* User Info */}
            <div className="p2p-user-section">
              <div className="p2p-user-avatar">
                {listing.user.initial}
              </div>
              
              <div className="p2p-user-info">
                <div className="p2p-user-name">
                  {listing.user.name}
                  {listing.user.verified && (
                    <svg className="p2p-verified-badge" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 0L9.5 5.5L15 7L9.5 8.5L8 14L6.5 8.5L1 7L6.5 5.5L8 0Z" fill="#22c35d"/>
                    </svg>
                  )}
                </div>
                
                <div className="p2p-user-stats">
                  <div className="p2p-stat p2p-stat-completion">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="currentColor" strokeWidth="1.5"/>
                      <path d="M6 3V6L8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <span>{listing.user.completionRate}</span>
                  </div>
                  
                  <div className="p2p-stat">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M10 5L6 1L2 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M6 1V7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M11 11H1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>{listing.user.orders}</span>
                  </div>
                  
                  <div className="p2p-stat">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.5"/>
                      <path d="M6 3V6L8 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <span>{listing.user.avgTime}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Price Info */}
            <div className="p2p-price-section">
              <div className="p2p-price-details">
                <div className="p2p-price-main">
                  <span className="p2p-price-amount">{listing.price}</span>
                  <span className="p2p-price-pair">{listing.pair}</span>
                </div>
                <div className="p2p-price-limit">
                  Limit {listing.currency} {listing.limitMin} - {listing.currency} {listing.limitMax}
                </div>
              </div>
              
              <div className="p2p-availability">
                <span className="p2p-availability-label">Available</span>
                <span className="p2p-availability-amount">{listing.available} USDT</span>
              </div>
            </div>

            {/* Payment Methods */}
            <div className="p2p-payment-methods">
              {listing.paymentMethods.map((method, index) => (
                <div key={index} className="p2p-payment-badge">
                  {method}
                </div>
              ))}
            </div>

            {/* Sell Button */}
            <button className="p2p-sell-button" onClick={handleSellClick}>
              Sell USDT
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default P2pSellList;